import React from 'react';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import * as groupApi from '../../../../../api/group';
import helper from '../../../../../utils/helper';
import AssignUsersPage from './AssignUsersPage';

class AssignUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      users: [],
      isSubmitting: false,
      errors: '',
      group: null,
    };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.usersByGroup !== prevState.users) {
      state.users = nextProps.configure.usersByGroup;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    state.errors = helper.centralizeError([nextProps.configure.errors]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    const { groupId } = this.props.match.params;
    await this.props.getUsersByGroup(groupId);
    groupApi
      .getGroupDetail(groupId)
      .then((group) => this.setState({ group }))
      .catch((err) => console.log(err));
  }
  onAssignUsers = (assignUserIds) => {
    const { groupId } = this.props.match.params;
    const unassignUserIds = this.state.users
      .filter((user) => !assignUserIds.includes(user.userId))
      .map((user) => user.userId);
    this.props
      .assignUsers(groupId, assignUserIds, unassignUserIds)
      .then(() => this.props.history.push('/configure/groups'))
      .catch((err) => console.log(err));
  };
  render() {
    return (
      <AssignUsersPage {...this.state} onAssignUsers={this.onAssignUsers} />
    );
  }
}
function mapStateToProps(state) {
  return {
    configure: state.configure,
  };
}
export default connect(mapStateToProps, configureActions)(AssignUsers);
